import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material'
import { FC } from 'react'

import { RepairOrderMediaEntry } from '../../../sdk'
import MediaGallery, { MediaEntryType } from '../../MediaGallery/MediaGallery'

interface Props {
  open: boolean
  handleClose: () => void
  media: RepairOrderMediaEntry[]
  repairOrderId: string
}

const RepairOrderMediaDialog: FC<Props> = ({
  open,
  handleClose,
  media,
  repairOrderId
}) => {
  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle>Media Gallery</DialogTitle>
      <DialogContent>
        <MediaGallery
          mediaEntryType={MediaEntryType.repairOrder}
          media={media}
          parentId={repairOrderId}
          isMobileDevice={false}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}

export default RepairOrderMediaDialog
